var map = {
	"./1.jpeg": 2398,
	"./10.jpeg": 4077,
	"./11.jpeg": 7944,
	"./12.jpeg": 5717,
	"./2.jpeg": 4933,
	"./3.jpeg": 4054,
	"./4.jpeg": 70,
	"./5.jpeg": 9757,
	"./6.jpeg": 5681,
	"./7.jpeg": 6257,
	"./8.jpeg": 6543,
	"./9.jpeg": 7395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2948;